<template>
    <div class="flex flex-col">
        <div class="h-2 w-full loading-bar"/>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.loading-bar {
    position: relative;
    overflow: hidden;
    background-color: rgba(51, 132, 72, 0.4);
}

.loading-bar::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(
                    90deg,
                    rgba(233, 233, 233, 0.1) 0,
                    rgba(233, 233, 233, 0.9) 50%,
                    rgba(233, 233, 233, 1) 100%
    );
    animation: shimmer 2s ease-out infinite;
    content: "";
}

@keyframes shimmer {
    100% {
        transform: translateX(0%);
        opacity: 30%;
    }
}

</style>